import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import { jsx, css } from "@emotion/react";
import { popoverOverlayZIndex } from "../../../../styles/z-indices";

const modalRoot = document.getElementById("modal-root") as HTMLElement;

const styles = {
  container: css`
    display: flex;
    position: absolute;
    z-index: ${popoverOverlayZIndex};
    align-self: center;
    top: 32px;
    height: calc(100vh - 32px - 32px);
    justify-content: center;
  `,
};

const PopoverOverlay = (props) => {
  const el = <div css={styles.container}>{props.children}</div>;

  return ReactDOM.createPortal(el, modalRoot);
};

export default PopoverOverlay;
